import React from 'react';
import { shape } from 'prop-types';
import PaginationComponent from '@magalu/stereo-ui/molecules/Pagination';
import { parsePageFilter, getCurrentPath, routePush } from '@magalu/mixer-utils';
import { usePublisher } from '@magalu/mixer-publisher';
import withLayoutProps from '../../../hocs/withLayoutProps';
var Pagination = function Pagination(_ref) {
  var structure = _ref.structure,
    staticProps = _ref["static"];
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var canonicalPath = structure.canonicalPath,
    query = structure.query;
  var _onChange = function onChange(e, page) {
    e.preventDefault();
    publish('paginate:click', {
      eventLabel: page
    });
    var path = getCurrentPath({
      page: page
    });
    routePush({
      path: path,
      spa: true
    });
  };
  var _ref2 = staticProps || {},
    pagination = _ref2.pagination;
  var currentPage = query.page;
  return React.createElement(PaginationComponent, {
    count: pagination == null ? void 0 : pagination.pages,
    page: parsePageFilter(currentPage),
    path: canonicalPath,
    onChange: function onChange(e, page) {
      return _onChange(e, page);
    }
  });
};
process.env.NODE_ENV !== "production" ? Pagination.propTypes = {
  "static": shape({
    pagination: shape({})
  }),
  structure: shape({})
} : void 0;
Pagination.defaultProps = {
  "static": {},
  structure: {}
};
Pagination.ssr = true;
export default withLayoutProps(Pagination);